import React from "react";
import Profile from "../../components/Profile/Profile";

export const ProfilePage = (): React.ReactElement => <Profile />;
